module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedSemiBoldItalic.e2dd56e.woff";